import { useState } from "react";
import { Plus } from "lucide-react";
import { Card, Table, Badge, Button } from "@marekl/adminer/components";
import { VoucherTypeModal } from "../VoucherTypeModal";
import { useVoucherTypes } from "../../../lib/queries/voucherTypes";
import type { VoucherType } from "../../../lib/queries/voucherTypes";
import { formatCurrency } from "@marekl/adminer/format";
import styles from "./VoucherTypesCard.module.css";

export function VoucherTypesCard() {
  const { data: types = [], isLoading } = useVoucherTypes();
  const [modal, setModal] = useState<
    { kind: "closed" } | { kind: "create" } | { kind: "edit"; vt: VoucherType }
  >({ kind: "closed" });

  return (
    <Card
      header={
        <Card.Header
          title="Typy voucherů"
          actions={
            <Button
              variant="primary"
              size="sm"
              onClick={() => setModal({ kind: "create" })}
            >
              <Plus size={14} aria-hidden="true" />
              Nový
            </Button>
          }
        />
      }
      bodyPadding="none"
    >
      <Table<VoucherType>
        rowKey={(vt) => vt.id}
        columns={[
          {
            key: "name",
            header: "Název",
            render: (vt) => (
              <span className={styles.name}>
                {vt.name}
                {!vt.active && (
                  <Badge variant="muted" className={styles.inactiveBadge}>
                    Neaktivní
                  </Badge>
                )}
              </span>
            ),
          },
          {
            key: "default_rides",
            header: "Jízd",
            tdClass: styles.num,
            render: (vt) => vt.default_rides,
          },
          {
            key: "price_czk",
            header: "Cena",
            tdClass: styles.num,
            render: (vt) => formatCurrency(vt.price_czk),
          },
          {
            key: "validity_months",
            header: "Platnost",
            tdClass: styles.num,
            render: (vt) => `${vt.validity_months} měs.`,
          },
          {
            key: "actions",
            header: "",
            render: (vt) => (
              <Table.Actions>
                <Table.Action onClick={() => setModal({ kind: "edit", vt })}>
                  Upravit
                </Table.Action>
              </Table.Actions>
            ),
          },
        ]}
        rows={types}
        empty={isLoading ? "Načítám…" : "Žádné typy voucherů."}
      />

      <VoucherTypeModal
        open={modal.kind !== "closed"}
        voucherType={modal.kind === "edit" ? modal.vt : null}
        onClose={() => setModal({ kind: "closed" })}
      />
    </Card>
  );
}
